<template>
    <div class="g-content g-autofixheight order">
        <div class="my-order-tabs my-order-tab-2">
            <div class="g-status">
                <a class="arrow-left js-status-left" href="#" @click="swiperPrev">
                    <i class="ico ico-arrow-left"></i>
                </a>
                <a class="arrow-right js-status-right" href="#" @click="swiperNext">
                    <i class="ico ico-arrow-right"></i>
                </a>
                <div class="swiper-container js-status-swiper" id="swiper-tab">
                    <div class="swiper-wrapper">
                        <div
                            class="swiper-slide"
                            v-for="(item,index) in pageConf.demandStatusList"
                            :key="item.id"
                        >
                            <div
                                class="title"
                                :class="{active: index == curSwiper}"
                                @click="changeSwiper(index,item)"
                            >
                                {{item.name}}
                                <span class="num">（{{item.num}}）</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="search f-clearfix">
                <select-box
                    style="font-size: 14px;color:#666"
                    :selectList="allGame"
                    :itemTitle="'游戏'"
                    :selected.sync="params.gameId"
                ></select-box>
                <select-box
                    style="font-size: 14px;color:#666"
                    :selectList="pageConf.contentTypeList"
                    :itemTitle="'订单类型'"
                    :selected.sync="params.type"
                    :placeHolder="'请选择订单类型'"
                ></select-box>

                <div class="list list-order-name">
                    <!--<div class="list">-->
                    <p class="name">
                        <label for="keyword">订单名称</label>
                    </p>
                    <div class="g-select f-fl">
                        <input
                            class="input"
                            name="keyword"
                            type="text"
                            placeholder="请输入订单名称"
                            v-model.trim="params.demandName"
                        >
                    </div>
                </div>
                <div class="inquire">
                    <input class="btn" type="button" value="查询" @click="getSupplierDemandList">
                </div>
            </div>
            <ul class="order-list">
                <li class="order-item f-clearfix" v-for="item in supplierDemandList" :key="item">
                    <a class="click-area" href="javascript:;" @click="viewDemandDetail(item)">
                        <div class="item-head">
                            <img :src="item.logoUrl" width="80" height="80">
                        </div>
                        <div class="item-intro">
                            <div class="item-name f-hide-col-1">
                                <p class="link">{{ item.demand_name }}</p>
                            </div>
                            <div class="order-intro">
                                <span class="order-num">
                                    <span class="order-num-text">单号：</span>
                                    {{ item.id }}
                                </span>
                                <span
                                    class="order-type"
                                >{{ item.demandTypeText }}({{ item.content_type }})</span>
                            </div>
                            <div class="date">
                                <span class="date-detail">{{ item.gameName}}</span>
                                {{ item.start_time }}~{{ item.end_time}}
                            </div>
                        </div>
                        <div class="budget">
                            <div class="break-num" v-if="item.content_type== 'UGC'">
                                已拆
                                <span class="break-detail">{{ item.separate }}</span>单
                            </div>
                            <div class="budget-all">
                                含税总预算
                                <span
                                    class="budget-all-num f-hide-col-1"
                                >{{ $common.toThousandsFilter(item.total_budget)}}</span>
                            </div>
                            <div class="budget-true">
                                含税实际额
                                <span
                                    class="budget-true-num f-hide-col-1"
                                >{{$common.toThousandsFilter(item.realAmount)}}</span>
                            </div>
                        </div>
                    </a>

                    <!-- 已结单[[ -->
                    <div class="status wait-check-success f-fr" v-if="item.demand_status === 4004">
                        <div class="status-text">已结单</div>
                    </div>
                    <!-- 已结单]] -->

                    <!-- 执行中[[ -->
                    <div
                        class="status wait-accept f-fr"
                        v-else-if="item.demand_status === 4003 && item.content_type == 'UGC'"
                    >
                        <div class="status-text">执行中</div>
                        <div class="operation">
                            <a class="g-btn" href="javascript:;" @click="unPackDemand(item)">拆单</a>
                        </div>
                    </div>
                    <!-- 执行中]] -->
                    <!-- 执行中[[ -->
                    <div
                        class="status wait-accept f-fr"
                        v-else-if="item.demand_status === 4003 && ['PGC','PUGC'].includes(item.content_type)"
                    >
                        <div class="status-text">执行中</div>
                        <div class="operation">
                            <a class="g-btn" href="javascript:;" @click="contribute(item)">投稿</a>
                        </div>
                    </div>
                    <!-- 执行中]] -->
                </li>
            </ul>

            <!-- 空数据 start -->
            <div class="empty" v-if="supplierDemandList.length===0">
                <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png">
            </div>
            <!-- 空数据 end -->
            <!-- 分页[[ -->
            <pagination
                v-if="paginationConf.total >0"
                :total="paginationConf.total"
                :page-size="paginationConf.pageSize"
                @change="pageChange"
                ref="pager"
            ></pagination>
            <!-- 分页]] -->
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/order.scss";
@import "~Assets/vendor/swiper/swiper-3.2.7.min.css";
</style>
<script>
import Swiper from "Assets/vendor/swiper/swiper-3.2.7.min.js";
import selectBox from "Components/v4/dropdown/select_box";
import pagination from "Components/v4/pagination/pagination_v4";
import {
    AllGame,
    SupplierDemandList,
    SupplierDemanStat
} from "Services/getData.js";
export default {
    name: "v4-order-demand",
    data() {
        return {
            pageConf: {
                demandStatusList: [
                    {
                        id: 0,
                        name: "全部",
                        num: ""
                    },
                    {
                        id: 4003,
                        name: "执行中",
                        num: ""
                    },
                    {
                        id: 4004,
                        name: "已结单",
                        num: ""
                    }
                ],
                contentTypeList: [
                    {
                        id: 0,
                        name: "全部类型"
                    },
                    {
                        id: 1,
                        name: "PGC"
                    },
                    {
                        id: 2,
                        name: "PUGC"
                    },
                    {
                        id: 3,
                        name: "UGC"
                    }
                ],
                demandTypeList: [
                    {
                        name: "内容创作",
                        id: 10
                    },
                    {
                        name: "劳务服务",
                        id: 20
                    },
                    {
                        name: "福利奖金",
                        id: 30
                    },
                    {
                        name: "补贴补偿",
                        id: 40
                    }
                ]
            },
            mySwiper: {},
            curSwiper: 0,
            allGame: [],
            supplierDemandList: [],
            params: {
                demandStatus: 0,
                gameId: "",
                type: "",
                demandName: "",
                pageSize: "",
                pageIndex: 0 // 从 0 开始
            },
            paginationConf: {
                total: 0,
                pageSize: 10
            }
        };
    },
    components: {
        selectBox,
        pagination
    },
    created() {
        this.getSupplierDemandStat().then(() => {
            this.initSwiper();
        });
    },
    mounted() {
        this.getAllGame();
        this.getSupplierDemandList();
    },
    methods: {
        initSwiper() {
            this.mySwiper = new Swiper("#swiper-tab", {
                paginationClickable: true,
                slidesPerView: "auto",
                initialSlide: 1,
                slideToClickedSlide: true,
                centeredSlides: true,
                onTransitionEnd: function(swiper) {
                    if (swiper.progress == 1) {
                        swiper.activeIndex = swiper.slides.length - 1;
                    }
                }
            });
        },
        swiperPrev() {
            this.mySwiper.slidePrev();
        },
        swiperNext() {
            this.mySwiper.slideNext();
        },
        changeSwiper(index, item) {
            this.curSwiper = index;
            this.params.demandStatus = item.id;
            this.getSupplierDemandList();
        },
        pageChange(param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.pageIndex = param.pageIndex - 1; // 发送给接口的字段
            this.getSupplierDemandList();
        },
        unPackDemand(demand) {
            // 拆单
            // let param = Object.assign({}, demand, { packType: 'add' });
            this.$router.history.push({
                name: "v4-order-supplier-unpack",
                query: {
                    demandId: demand.id
                }
            });
        },
        contribute(demand) {
            // 投稿
            // demand.type = 'demand';
            // this.$router.history.push({name:'v4-order-contribute',params:demand});
            this.$router.history.push({
                name: "v4-order-contribute",
                query: {
                    demandId: demand.id,
                    authorOrderId: demand.authorOrderId,
                    demandType: 2
                }
            });
        },
        viewDemandDetail(demand) {
            let pathName = "";
            if (demand.content_type == "UGC") {
                pathName = "v4-order-demand-detail-ugc";
                return this.$router.history.push({
                    name: pathName,
                    query: {
                        demandId: demand.id
                    }
                });
            } else {
                demand.type = "demand";
                pathName = "v4-order-supplier-detail-pugc";
                this.$router.history.push({
                    name: pathName,
                    query: {
                        demandId: demand.id
                    }
                });
            }
        },
        async getSupplierDemandStat() {
            let res = await SupplierDemanStat();
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    let { all, execute, finished } = res.data.data;
                    this.pageConf.demandStatusList.map(v => {
                        if (v.id === 0) {
                            v.num = all;
                        } else if (v.id === 4003) {
                            v.num = execute;
                        } else {
                            v.num = finished;
                        }
                    });
                }
            }
        },
        async getSupplierDemandList() {
            let param = this.params;
            let res = await SupplierDemandList(param);
            if (res.status === 200 && res.data.code == 0) {
                let data = res.data;
                if (data.code != 0) {
                    // this.$alert(data.info);
                } else {
                    let demandList = data.data.data;
                    let demandTypeList = {};
                    this.pageConf.demandTypeList.filter(type => {
                        demandTypeList[type.id] = type.name;
                    });
                    this.supplierDemandList = demandList.map(demand => {
                        demand.demandTypeText =
                            demandTypeList[demand.demand_type];
                        return demand;
                    });
                    this.paginationConf.total = data.data.count;
                }
            }
        },
        async getAllGame() {
            let res = await AllGame();
            if (res.data && res.data.data.length) {
                this.allGame = res.data.data;
                this.allGame.unshift({
                    id: 0,
                    name: "全部"
                });
            }
        }
    }
};
</script>

